import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ForgotPassword from './ForgotPassword';
import Login from './Login';
import RegisterUser from './RegisterUser';
import RegisterCompany from './RegisterCompany';
import CreateCompany from './CreateCompany';
import GtmPageView from '../analytics/GtmPageView';

const AuthRouter: React.FC = () => {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <GtmPageView />
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/register-company" element={<RegisterCompany />} />
                <Route path="/register-company/:type" element={<RegisterCompany />} />
                <Route path="/create-company/:type" element={<CreateCompany />} />
                <Route path="/register-user" element={<RegisterUser />} />
                <Route path="*" element={<Login />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AuthRouter;
